type GlideFit = 'contain' | 'fill' | 'max' | 'stretch' | 'crop' | string;

interface GlideImageArgs {
  w?: number;
  h?: number;
  fit?: GlideFit;
  [key: string]: string | number | undefined;
}

export default function glideImage(src: string, args: GlideImageArgs): string {
  if (!src || !src?.includes('/img/')) {
    return src;
  }

  const parts = src.split('.');
  let result = parts.slice(0, parts.length - 1).join('.');

  Object.keys(args).forEach((key) => {
    result += `-${key}_${args[key]}`;
  });

  result += `.${parts[parts.length - 1]}`;

  return result;
}
